import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { EMPTY } from "rxjs";
import { tap } from "rxjs/operators";
import { FpcsStateModel } from "./fpcs.state.model";
import { FpcsApiService } from "src/app/services/api/fpcs-api.service";
import { FpcsActions } from "./fpcs.actions";

@State<FpcsStateModel>({
    name: 'fpcFamilies',
    defaults: {
        fpcFamilies: []
    },
})
@Injectable()
export class FpcsState{
    constructor(private fpcsApiService: FpcsApiService) {}

    @Action(FpcsActions.SetAllFpcs)
    SetAllFpcs(ctx: StateContext<FpcsStateModel>) {
        const state = ctx.getState();
        //don't update state if we have already downloaded items
        if (state.fpcFamilies && state.fpcFamilies.length > 0)
            return EMPTY;

        return this.fpcsApiService.get().pipe(
            tap(fpcs => {
                if (fpcs) {
                  var allFpcFamilies = fpcs;
                  ctx.patchState({fpcFamilies: allFpcFamilies});
                }
            })
        );
    }

    @Selector()
    static getAllFpcs(state: FpcsStateModel){
        return state.fpcFamilies;
    }
}